import debug from "debug";

const MODULE_NAME = 'app.core';
const log = debug(MODULE_NAME);
log('Running...');

import "./plugins";
import components from './components';
// import services from './services';

$(() => {
    log('Running document ready tasks...');
    log('components', components);
    components.exec();
});



// WEBPACK FOOTER //
// ./client/src/core/index.js